import React, { Fragment, useMemo } from 'react';
import classNames from 'classnames';
import EfImg from '../ef-img';
import './index.scss';

const correct = (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
        <path
            d="M2.40723 14.8792L11.7694 24.2399C11.787 24.2575 11.8166 24.2534 11.8287 24.2316L24.4072 1.7251"
            stroke="currentColor"
            strokeWidth="3.22141"
            strokeLinecap="round"
        />
    </svg>
);

// 暂无 UI
const error = null;

export interface EfProductCompare2Props {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 数据组A
     */
    dataGroupA: {
        title: string;
        subTitle?: string;
        url: string;
        data: { [key: string]: any };
    };
    /**
     * 数据组B
     */
    dataGroupB: {
        title: string;
        subTitle?: string;
        url: string;
        data: { [key: string]: any };
    };
}

/**
 * 维护: Hzihhuang（黄子豪）
 * 产品比较组件
 */
const EfProductCompare2: React.FC<EfProductCompare2Props> = ({ dataGroupA, dataGroupB, className }) => {
    const attrs = useMemo(() => Object.keys(dataGroupA.data), [dataGroupA]); // 获取对比的属性列表
    const products = useMemo(() => [dataGroupA, dataGroupB], [dataGroupA, dataGroupB]); // 获取对比的产品列表

    /** 如果是 1 或 0 的时候就显示 ✅ or ❌ */
    const getBooleanEl = (val: string | boolean) => {
        if (val === true) {
            return correct;
        } else if (val === false) {
            return error;
        }
        return val;
    };

    return (
        <div className={classNames('ef-product-compare-2', className)}>
            {/* 产品 —— 「名字｜图片」 */}
            <div className="ef-product-compare-head">
                {products.map((i, idx) => (
                    <Fragment key={i.title}>
                        <div className={`ef-product-compare-head-item ef-product-compare-head-item-${idx}`}>
                            <div className="ef-product-compare-head-info">
                                <span className="ef-product-compare-head-title">{i.title}</span>
                                {i.subTitle && <span className="ef-product-compare-head-subTitle">{i.subTitle}</span>}
                            </div>
                            <EfImg className="ef-product-compare-head-img" pc={i.url} />
                        </div>
                        {idx === 0 && (
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1732589676893/VS.png" className="ef-product-compare-head-vs"></EfImg>
                        )}
                    </Fragment>
                ))}
            </div>
            {/* 表格 */}
            <div className="ef-product-compare-table">
                {attrs.map((i, idx1) => (
                    <div className="ef-product-compare-tr" key={idx1}>
                        {products.map((j, idx2) => (
                            <Fragment key={`${idx1}-${idx2}`}>
                                <div className="ef-product-compare-td">{getBooleanEl(j.data[i])}</div>
                                {idx2 === 0 && (
                                    <div className="ef-product-compare-attr" key={i}>
                                        <div className="ef-product-compare-attr-name">{i}</div>
                                    </div>
                                )}
                            </Fragment>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EfProductCompare2;
